import {useI18n} from 'i18n/I18nContext'
import React, {useId, useMemo, type ReactNode} from 'react'
import styled from 'styled-components'

export const FAQ_ORDER = [
  'buyTicket',
  'whenJoin',
  'privatePageVisibility',
  'multiDevices',
  'addToCalendar',
  'techIssues',
  'supportedDevices',
  'switchDevice',
  'emails',
  'notReceivedEmail',
  'certificates',
  'paymentsSecure',
  'refunds',
  'forgotPassword',
  'changeEmail',
  'audioVideo',
  'chatQna',
  'language',
] as const

export type FAQKey = (typeof FAQ_ORDER)[number]

type FAQItemData = {
  question: string
  answer: string
}

export function FAQ(): JSX.Element {
  const {t} = useI18n()
  const items = useMemo((): Record<FAQKey, FAQItemData> => {
    const out = {} as Record<FAQKey, FAQItemData>
    for (const key of FAQ_ORDER) {
      out[key] = {
        question: t(`attendeeFaq.${key}.question`),
        answer: t(`attendeeFaq.${key}.answer`),
      }
    }
    return out
  }, [t])

  return (
    <div className="accordion" id="accordionFAQ">
      {FAQ_ORDER.map((key, index) => {
        const item = items[key]
        return (
          <FAQItem
            key={key}
            open={index === 0}
            question={item.question}
            answer={item.answer}
          />
        )
      })}
    </div>
  )
}

export function FAQItem(props: {
  question: string
  answer: string | ReactNode
  open?: boolean
}): JSX.Element {
  const {question, answer, open} = props

  const reactId = useId()
  const id = `faq-${reactId}`

  return (
    <StyledItem className="accordion-item">
      <h2 className="accordion-header">
        <span
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          data-bs-toggle="collapse"
          data-bs-target={`#${id}`}
          aria-expanded={open ? 'true' : 'false'}
          aria-controls={id}
        >
          <span className="accordion__heading">{question}</span>
        </span>
      </h2>
      <div
        id={id}
        className={`accordion-collapse collapse ${open ? 'show' : ''}`}
        data-bs-parent="#accordionFAQ"
      >
        <div className="accordion-body">
          <div className="accordiong__inner">
            <div className="accordion__title-inner mb-25">
              {typeof answer === 'string' ? (
                <p style={{whiteSpace: 'pre-line'}}>{answer}</p>
              ) : (
                answer
              )}
            </div>
          </div>
        </div>
      </div>
    </StyledItem>
  )
}

const StyledItem = styled.div`
  & > .accordion-header .accordion-button {
    background: #f5f5f5;
  }

  & .accordion-button:not(.collapsed) {
    background: var(--clr-gradient-14);
    color: #ffffff;
    font-weight: bold;
  }

  & .accordion-body {
    background: #f5f5f5;
  }

  margin-bottom: 20px;
  border: none;
`
